export default "__VITE_ASSET__4aApqlNk__"